import React from 'react'
import PropTypes from 'prop-types'

import { separateCategoryStatusesAllowedEditing } from '../../util/categoryConsts'
import { FlexColumn, FlexRow } from '../styles/Containers'
import CategorySelector from './CategorySelector'
import CategoryFileTable from './CategoryFileTable'
import CategoryUploadFilesButton from './CategoryUploadFilesButton'

function Categories({
  categories,
  foiId,
  activeCategory,
  disabled = false,
  // Preserve undefined so the preview can distinguish loading from removal.
  files,
  preview = null,
  onPreviewConsumed,
  duplicateGroups = [],
  handleSelectCategory = () => {},
  handleUploadFiles = () => {},
  handleRemoveFile = () => {},
  handleRestoreFile = () => {},
  handleUpdateWorkflow = () => {},
  handleAddRemoveResponseFiles = () => {},
  handleRenameFile = () => {}
}) {
  const categoriesAllowedUpload = categories
    .filter(c => c.name !== 'Removed Files' && separateCategoryStatusesAllowedEditing.includes(c.status))
    .map(c => {
      return { id: c.id, label: c.name }
    })

  return (
    <FlexColumn gap="15px">
      <FlexRow width="100%">
        <CategoryUploadFilesButton categories={categoriesAllowedUpload} foiId={foiId} onSuccess={handleUploadFiles} disabled={disabled} />
        {activeCategory && <CategorySelector defaultCategory={activeCategory.id} categories={categories} onSelectCategory={handleSelectCategory} />}
      </FlexRow>
      {activeCategory && (
        <CategoryFileTable
          category={activeCategory}
          foiId={foiId}
          categories={categoriesAllowedUpload}
          files={files}
          preview={preview}
          onPreviewConsumed={onPreviewConsumed}
          duplicateGroups={duplicateGroups}
          disabled={disabled}
          handleRemoveFile={handleRemoveFile}
          handleRestoreFile={handleRestoreFile}
          handleUpdateWorkflow={handleUpdateWorkflow}
          handleAddRemoveResponseFiles={handleAddRemoveResponseFiles}
          handleUploadFiles={handleUploadFiles}
          handleRenameFile={handleRenameFile}
        />
      )}
    </FlexColumn>
  )
}

Categories.propTypes = {
  categories: PropTypes.array.isRequired,
  foiId: PropTypes.string.isRequired,
  activeCategory: PropTypes.object,
  disabled: PropTypes.bool,
  files: PropTypes.array,
  preview: PropTypes.shape({
    fileId: PropTypes.string.isRequired,
    filename: PropTypes.string,
    page: PropTypes.number,
    nonce: PropTypes.number
  }),
  onPreviewConsumed: PropTypes.func,
  duplicateGroups: PropTypes.array,
  handleSelectCategory: PropTypes.func,
  handleUploadFiles: PropTypes.func,
  handleRemoveFile: PropTypes.func,
  handleRestoreFile: PropTypes.func,
  handleUpdateWorkflow: PropTypes.func,
  handleAddRemoveResponseFiles: PropTypes.func,
  handleRenameFile: PropTypes.func
}

export default Categories
